export type DateTime = string;

export type WMDatatype = string;

export interface WMValue<T> {
    type: WMDatatype,
    data: T
}

export interface RemoteError {
    id: string,
    description: string,
    incidentId: string,
    args: any,
    stackTrace?: string
}

export interface Progress {
    current: number;
}

export interface UserMessage {
    code: string;
    arguments?: Record<string, string>;
    fallback?: string;
}

export type EventType = string;

export type EventSource = string;

/**
 * Generic event that may be emitted from deep component hierarchies and bubble up.
 */
export class WebmateEvent {
  constructor(public readonly sourceComponent: EventSource, public readonly eventType: EventType, public readonly data?: any) {}
}

export interface StateComparisonUIEvent{
    type: string,
    params : any
}

export type SmallId = string;
